import React, { ReactNode } from 'react'
import styles from './styles.module.scss'

interface Props extends React.HTMLAttributes<HTMLHeadingElement> {
  level?: 'h1' | 'h2' | 'h3'
  children?: ReactNode
  className?: string
}

export const Title = ({ level = 'h1', children, className }: Props) => {
  const textSize = {
    h1: 'text-2xl sm:text-4xl lg:text-5xl',
    h2: 'text-2xl sm:text-4xl lg:text-5xl',
    h3: 'text-2xl sm:text-4xl lg:text-5xl'
  }

  const Heading = level

  return (
    <Heading
      className={`
        ${styles.title}
        ${textSize[level.toString()]}
        ${className}
      `}
    >
      {children}
    </Heading>
  )
}
